import { ArrowUpRight, Scale } from "lucide-react";

import { Label } from "@/components/ui/label";
import { NumberInput } from "@/components/ui/number-input";

import type { useRepackingForm } from "./use-repacking-form";

type Form = ReturnType<typeof useRepackingForm>;

/** Expected bar yield of the opened packages, with an optional actual yield (gap = susut). */
export function RepackingOutputField({ form }: { form: Form }) {
  const { selectedItem, inputQty, opensInto, expectedQty, outputUom } = form;
  if (!selectedItem || inputQty <= 0) return null;

  const fmt = (n: number) => n.toLocaleString("id-ID");
  const outputName = opensInto?.name ?? selectedItem.name;

  return (
    <div className="rounded-lg border p-3 space-y-2">
      <Label className="text-xs font-semibold flex items-center gap-1.5">
        <ArrowUpRight className="h-4 w-4 text-emerald-500" />
        Masuk ke Stok Bar
      </Label>
      <p className="text-xs text-foreground">
        {fmt(inputQty)} {selectedItem.uomName}
        {opensInto && " × isi kemasan"} ={" "}
        <strong>
          {fmt(expectedQty)} {outputUom} {outputName}
        </strong>
      </p>

      <div>
        <Label
          htmlFor="output-qty"
          className="text-[11px] text-muted-foreground"
        >
          Hasil aktual (isi bila kurang dari seharusnya, misal tumpah)
        </Label>
        <div className="mt-1 flex items-center gap-2">
          <NumberInput
            id="output-qty"
            decimals={4}
            placeholder={fmt(expectedQty)}
            value={form.outputQtyStr ? Number(form.outputQtyStr) : undefined}
            onChange={(n) => form.setOutputQtyStr(n ? String(n) : "")}
            className="h-10 text-xs sm:h-9"
          />
          <span className="min-w-14 text-center text-xs font-medium text-muted-foreground">
            {outputUom}
          </span>
        </div>
      </div>

      {form.isOutputOverExpected ? (
        <p className="text-[11px] text-destructive">
          Hasil tidak boleh melebihi {fmt(expectedQty)} {outputUom}.
        </p>
      ) : (
        form.shrinkageQty > 0 && (
          <p className="flex items-center gap-1 text-[11px] text-rose-600 dark:text-rose-400">
            <Scale className="h-3 w-3" />
            Susut {fmt(form.shrinkageQty)} {outputUom} dicatat sebagai kerugian.
          </p>
        )
      )}
    </div>
  );
}
